var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmplify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2754 9.94999C12.6004 8.58332 11.4088 7.39161 10.0421 7.71661C9.40043 7.87494 8.87543 8.39996 8.7171 9.04163C8.3921 10.4083 9.58376 11.6 10.9504 11.275C11.6004 11.1166 12.1254 10.5917 12.2754 9.94999Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.51647 15.4751C5.36647 15.4751 5.20813 15.4168 5.09146 15.3084C3.47479 13.8084 2.5498 11.6917 2.5498 9.49173C2.5498 5.1084 6.11647 1.54175 10.4998 1.54175C14.8831 1.54175 18.4498 5.1084 18.4498 9.49173C18.4498 11.7084 17.5581 13.7584 15.9415 15.2834C15.6915 15.5167 15.2915 15.5084 15.0581 15.2584C14.8248 15.0084 14.8331 14.6084 15.0831 14.3751C16.4498 13.0918 17.1998 11.3667 17.1998 9.50007C17.1998 5.8084 14.1915 2.80009 10.4998 2.80009C6.80813 2.80009 3.7998 5.8084 3.7998 9.50007C3.7998 11.3834 4.55813 13.1167 5.94146 14.4001C6.19146 14.6334 6.20814 15.0334 5.97481 15.2834C5.84981 15.4084 5.68314 15.4751 5.51647 15.4751Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.8336 13.25C13.6836 13.25 13.5253 13.1917 13.4086 13.0834C13.1586 12.85 13.1419 12.45 13.3836 12.2C14.0753 11.4667 14.4586 10.5 14.4586 9.50004C14.4586 7.31671 12.6836 5.55005 10.5086 5.55005C8.33359 5.55005 6.55859 7.32504 6.55859 9.50004C6.55859 10.5084 6.94192 11.4667 7.63359 12.2C7.86692 12.45 7.85859 12.85 7.60859 13.0834C7.35859 13.325 6.95859 13.3084 6.72526 13.0584C5.81692 12.0917 5.30859 10.825 5.30859 9.50004C5.30859 6.63337 7.64192 4.30005 10.5086 4.30005C13.3753 4.30005 15.7086 6.63337 15.7086 9.50004C15.7086 10.825 15.2086 12.0917 14.2919 13.0584C14.1669 13.1834 14.0003 13.25 13.8336 13.25Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08295 14.3834L7.88295 15.8751C6.93295 17.0668 7.77461 18.8251 9.29961 18.8251H11.6913C13.2163 18.8251 14.0663 17.0584 13.108 15.8751L11.9079 14.3834C11.1913 13.4751 9.80795 13.4751 9.08295 14.3834Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplify);
export default __webpack_public_path__ + "static/media/amplify.6f015c4a21f38ca5abf4693665625bff.svg";
export { ForwardRef as ReactComponent };